export enum AuthState {
	Unknown = 'unknown',
	Unauthenticated = 'unauthenticated',
	Authenticated = 'authenticated',
}
